import { Link } from "react-router-dom";

import { SignupForm } from "@/features/auth";

export function SignupPage() {
  return (
    <div className="min-h-screen bg-background bg-hero-radial">
      <div className="flex min-h-screen items-center justify-center px-4 py-10">
        <div className="w-full max-w-md space-y-6">
          <Link
            to="/"
            className="flex items-center justify-center text-base font-semibold tracking-display-tight text-copy transition-colors hover:text-primary"
            aria-label="Go to OneShift home"
          >
            OneShift
          </Link>

          <div className="rounded-xl border border-border bg-surface p-8 shadow-card">
            <div className="mb-6 text-center">
              <h1 className="text-2xl font-semibold tracking-display-tight text-copy">
                Create your account
              </h1>
            </div>
            <SignupForm />
          </div>
        </div>
      </div>
    </div>
  );
}
